// TenantNavbar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../../../assets/logg.jpeg';
import './tenantNavbar.css';

const TenantNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogin = () => {
    navigate('/Oceanstar/Login');
  };

  const navItems = [
    { href: '/', label: 'Platform' },
    { href: '/competency', label: 'Competency' },
    { href: '/industries', label: 'Industries' },
    { href: '/services', label: 'Services' },
    { href: '/services#about', label: 'About' },
    { href: '/Landingpage_mentor', label: 'Mentor' },
  ];

  const isActive = (href) => {
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      return location.pathname === path && location.hash === `#${hash}`;
    }
    if (href === '/') {
      return location.pathname === '/';
    }
    return location.pathname === href || location.pathname.startsWith(href);
  };

  const handleNavClick = (e, href) => {
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      if (location.pathname === path) {
        e.preventDefault();
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          window.history.pushState(null, '', href);
        }
      }
    }
  };

  return (
    <header className={`navbar-header ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-inner">
          {/* Logo */}
          <Link to="/" className="navbar-brand">
            <img 
              src={logo} 
              alt="Platform Logo" 
              className="navbar-logo"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="navbar-nav-desktop" aria-label="Main navigation">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`nav-link-desktop ${isActive(item.href) ? 'active' : ''}`}
                onClick={(e) => handleNavClick(e, item.href)}
              >
                {item.label}
                <span className={`nav-link-underline ${isActive(item.href) ? 'active' : ''}`} />
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="navbar-cta-desktop">
            <Link to="/join-ecosystem" className="btn-join">
              Join Ecosystem
            </Link>
            <button onClick={handleLogin} className="btn-login">
              Login
            </button>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="navbar-toggle"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="navbar-mobile-menu">
            <nav className="navbar-mobile-nav" aria-label="Mobile navigation">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`nav-link-mobile ${isActive(item.href) ? 'active' : ''}`}
                  onClick={(e) => {
                    setIsMobileMenuOpen(false);
                    handleNavClick(e, item.href);
                  }}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/join-ecosystem"
                className="btn-join-mobile"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Join Ecosystem
              </Link>
              <button
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  handleLogin();
                }}
                className="btn-login-mobile"
              >
                Login
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default TenantNavbar;